import { ElMessage } from "element-plus";
import router from "../router";

const AUTH_EXPIRED_CODES = [70001, 70002];
// const AUTH_EXPIRED_CODES = [-1, 70001, 70002];
const displayedBusinessMessages = new Set();
let handlingAuthExpiry = false;

export const isAuthExpiredCode = (code) => AUTH_EXPIRED_CODES.includes(Number(code));

export const isRequestErrorHandled = (error) => Boolean(error && error.__requestErrorHandled);

export const isAuthExpiredError = (error) => Boolean(error && error.__authExpiredHandled);

export const resetAuthExpiredState = () => {
  handlingAuthExpiry = false;
};

export const createAuthExpiredError = () => {
  const error = new Error("AUTH_EXPIRED_HANDLED");
  error.__authExpiredHandled = true;
  error.__requestErrorHandled = true;
  return error;
};

export const createBusinessError = () => {
  const error = new Error("BUSINESS_ERROR_HANDLED");
  error.__requestErrorHandled = true;
  return error;
};

export const getResponseMessage = (response) => (
  response.data.msg || response.data.message || "请求失败，请稍后重试"
);

export const showBusinessError = (message) => {
  if (displayedBusinessMessages.has(message)) return;

  displayedBusinessMessages.add(message);
  ElMessage.error(message);
  setTimeout(() => displayedBusinessMessages.delete(message), 2000);
};

export const handleAuthExpired = (message) => {
  if (handlingAuthExpiry) return;

  handlingAuthExpiry = true;
  sessionStorage.removeItem("token");
  ElMessage({
    message: message || "登录失效，请重新登录",
    type: "error",
    center: true,
  });

  if (router.currentRoute.value.name !== "Login") {
    router.replace("/Login").catch(() => {});
  }
};
